import {
  createSharedClientGatewayConfig,
  getRuntimeAuthGatewayBaseUrl,
  sharedClientAuthStorageKey,
} from "@miadvg/auth-gateway/next-client";

import { BOOKING_STAFF_APP_SLUG } from "@/lib/auth/staff-shared";

/** Client auth-gateway app slug (registered as `booking`). */
export function getBookingClientAuthAppSlug(): string {
  return (
    process.env.NEXT_PUBLIC_CLIENT_AUTH_APP_SLUG?.trim() ||
    process.env.AUTH_GATEWAY_APP_SLUG?.trim() ||
    BOOKING_STAFF_APP_SLUG
  );
}

export const BOOKING_CLIENT_AUTH_CALLBACK_PATH = "/auth/client/callback";
export const BOOKING_CLIENT_SESSION_ENDPOINT_PATH = "/api/client/v1/session";

export function createBookingClientGatewayConfig() {
  return createSharedClientGatewayConfig({
    appSlug: getBookingClientAuthAppSlug(),
    getGatewayBaseUrl: getRuntimeAuthGatewayBaseUrl,
    sessionEndpointPath: BOOKING_CLIENT_SESSION_ENDPOINT_PATH,
    storage: "local",
    storageKey: sharedClientAuthStorageKey,
  });
}

export {
  getRuntimeAuthGatewayBaseUrl,
  sharedClientAuthStorageKey,
};
